/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/tau.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns the ratio of a circle’s circumference to its radius.
 *
 * @example
 * ROW TAU()
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'tau',
  signatures: [
    {
      params: [],
      variadic: false,
      returnType: 'double',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
